import React from 'react'
import { GetDetail } from './../Api'
import Config from '../Config'
const { platform } = Config()
const PageSize = 10

export default class QuestionDetailCom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            questionIndex: -9999, // 二级导航栏index
            currentPaginationIndex: 1
        }
    }


    componentDidMount() {
        let { knowledgeBaseID } = this.props

        if (knowledgeBaseID) {
            this.getCategoriesDetail({
                knowledgeBaseID,
                questionIndex: this.getQuestionIndex(),
                isShow: true
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (platform == 'Mobile' && prevProps?.routerName != this.props?.routerName && this.props?.routerName == 'QuestionDetail' && prevProps?.routerName.includes('isBackPage')) {
            this.setState({
                questionIndex: -9999
            })
        }
    }

    getQuestionIndex() {
        let { knowledgeBaseID, categories } = this.props
        let questionIndex = this.state.questionIndex
        let tempArr = []
        categories.forEach(v1 => {
            questionIndex = v1.articles.findIndex(v2 => v2.knowledgeBaseID == knowledgeBaseID)
            tempArr.push(questionIndex)
        });

        return tempArr.find(v => v >= 0)
    }



    async getCategoriesDetail({ isBack = false, knowledgeBaseID, questionIndex = this.state.questionIndex, isShow = false }) {
        if (isBack) {
            this.setState({
                questionIndex: -999
            })
        } else {
            let { tempCategories, categories } = this.props
            let { articles } = tempCategories

            // if (questionIndex == this.state.questionIndex) {
            //     this.setState({
            //         questionIndex: -999
            //     })
            //     return
            // }

            let tempCategoriesIndex = articles.findIndex(v => v.knowledgeBaseID == knowledgeBaseID)
            if (!!!articles[questionIndex]?.content) {
                let detail = await GetDetail({ knowledgeBaseID })
                if (Array.isArray(articles) && articles.length) {
                    articles[tempCategoriesIndex].content = detail?.content
                }
            }
            //articles[tempCategoriesIndex].isShow = isShow
            articles.forEach((v, i) => {
                if (tempCategoriesIndex == i) {
                    v.isShow = isShow
                } else {
                    v.isShow = false
                }
            })

            this.setState({
                questionIndex
            })


            if ((tempCategoriesIndex + 1) > PageSize) {
                let currentPaginationIndex = Math.ceil((tempCategoriesIndex + 1) / PageSize)
                this.changePaginationIndex(currentPaginationIndex)
            } else {
                this.changePaginationIndex(1)
            }
        }
    }


    changePaginationIndex(currentPaginationIndex) {
        this.setState({
            currentPaginationIndex
        })
    }


    render() {
        const { questionIndex, currentPaginationIndex } = this.state
        const { Content } = this.props
        return <>
            <Content
                questionIndex={(questionIndex) > 10 ? ((questionIndex) % PageSize) : questionIndex}
                getCategoriesDetail={this.getCategoriesDetail.bind(this)}
                currentPaginationIndex={currentPaginationIndex}
                PageSize={PageSize}
                changePaginationIndex={this.changePaginationIndex.bind(this)}
            ></Content>
        </>
    }
}